const DETAILS_THREE_DECIMAL_FIELDS = new Set<string>(['110056', '110057', '110058', '110059']);
const DETAILS_INTEGER_WHEN_WHOLE_FIELDS = new Set<string>(['110028', '110029', '110030']);
const TOTALS_TWO_DECIMAL_FIELDS = new Set<string>(['1000000001']);

export function getDetailsDecimals(fieldId: string | number, value?: unknown): number {
  const id = String(fieldId);
  if (DETAILS_THREE_DECIMAL_FIELDS.has(id)) return 3;
  if (DETAILS_INTEGER_WHEN_WHOLE_FIELDS.has(id) && isWholeNumber(value)) return 0;
  return 1;
}

export function getTotalsDecimals(fieldId: string | number): number {
  return TOTALS_TWO_DECIMAL_FIELDS.has(String(fieldId)) ? 2 : 0;
}

export function formatEaNumber(value: unknown, decimals: number): string {
  if (value === null || value === undefined || typeof value !== 'number' || !Number.isFinite(value)) {
    return value == null ? '' : String(value);
  }
  const factor = 10 ** decimals;
  return (Math.round(value * factor) / factor).toFixed(decimals);
}

function isWholeNumber(value: unknown): boolean {
  return typeof value === 'number' && Number.isFinite(value) && value % 1 === 0;
}
